import { lazy, Suspense } from 'react';

const AdminPage = lazy(() => import('@/pages/admin/admin-page'));
const AdminRoutes = {
	path: '/admin',
	element: (
		<Suspense
			fallback={
				<div
					role="status"
					style={{
						margin: 'auto',
						color: '#6686b9',
						fontFamily: 'Pretendard, sans-serif'
					}}
				>
					관리자 화면을 준비하고 있어요.
				</div>
			}
		>
			<AdminPage />
		</Suspense>
	)
};
export default AdminRoutes;
